import { buildCommonTelecomContractParameters } from '../buildCommonTelecomContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  return buildCommonTelecomContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    contactPreferences,
    action,
  })
}
